import ReportHeading from './reportHeading'
export default ReportHeading
